import React from 'react';
const CHECKOUT_URL = 'https://betterdailyguides.com/cart/51925795668270:1';
interface GuaranteeSectionProps {
  onBuyClick: (e: React.MouseEvent) => void;
}
export function GuaranteeSection({
  onBuyClick
}: GuaranteeSectionProps) {
  return <section className="bg-white py-16 px-5" data-id="element-102">
      <div className="max-w-[700px] mx-auto bg-gradient-to-br from-[#FAF7F2] to-[#F0E8DE] rounded-3xl p-10 text-center border-2 border-[rgba(183,110,121,0.2)]" data-id="element-103">
        <div className="text-7xl mb-5" data-id="element-104">🛡️</div>
        <h2 className="text-3xl md:text-4xl text-[#3D2B1F] mb-4" data-id="element-105">
          30-Day Total Guarantee
        </h2>
        <p className="text-base text-[#6B4C3B] font-sans leading-relaxed mb-6" data-id="element-106">
          Try the B.A.B.Y. 365 Protocol for a full 30 days. If you don't
          experience a noticeable improvement in your baby's sleep and greater
          clarity about their development, we will refund 100% of your money. No
          questions asked. No forms. A single email is enough.
        </p>
        <p className="font-bold text-[#B76E79] text-lg mb-6" data-id="element-107">
          The risk is completely ours. The future belongs to your baby.
        </p>
        <a href={CHECKOUT_URL} onClick={onBuyClick} className="inline-block bg-gradient-to-r from-[#B76E79] to-[#8B4A52] text-white text-lg font-bold py-4 px-8 rounded-full text-center tracking-wide shadow-lg hover:shadow-xl transition-all hover:-translate-y-1 font-sans uppercase animate-cta-pulse max-w-md" data-id="element-108">
          ⚡ TRY RISK-FREE FOR $12.97 →
        </a>
      </div>
    </section>;
}